'use client';
import { createContext, FC, useContext } from 'react';
import { type TypeKeyValueList } from '@/core/generated-types';
import generateTranslationsObject from '@/utils/translations/generateTranslationObject';

type PageTranslationsContextValue = { [key: string]: string };

interface PageTranslationProps {
  children: any;
  translations?: TypeKeyValueList;
}

const PageTranslationContext = createContext(
  {} as PageTranslationsContextValue,
);

export const usePageTranslations = () => useContext(PageTranslationContext);

export const PageTranslationsProvider: FC<PageTranslationProps> = ({
  translations,
  children,
}) => {
  const formattedTranslations = generateTranslationsObject(
    translations?.fields,
  );

  return (
    <PageTranslationContext.Provider value={formattedTranslations}>
      {children}
    </PageTranslationContext.Provider>
  );
};
